import { useOrganizationStore, useUserStore } from 'store/modules';

export default function (to, from, next) {
    const userStore = useUserStore();
    const organizationStore = useOrganizationStore();

    if (
        to.matched.some((record) => record.meta.owner) &&
        userStore.user.id !== organizationStore.organization.owner_id
    ) {
        next('/');
    } else {
        next();
    }
}
